module.exports = __webpack_public_path__ + "media/admin/cs_publication_004_lg-52684662.png";